import Vue from './vue/common/vue-common';
import BusinessToBusiness from './vue/components/b2b/BusinessToBusiness.vue';

cr$.ready(function () {
    new Vue({
        el: '#business-to-business',
        components: { BusinessToBusiness },
    });
});
